/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "97444f2add86854543a4a0570c18073e57b94257";
